import { get_project_by_id } from '@/api/mjstore-model';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import cacheRemoteSelect from '@/components/FormRender/utils';

const org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
const search_config: any = {
  model: {
    org_id: org?.id,
    is_active: true,
    pageSize: 2000,
  },
  watch: ['project_id'],
};

export default (modelType?: string) => {
  return {
    getData: cacheRemoteSelect(get_project_by_id, modelType),
    searchConfig: search_config,
  };
};
